const SUPER_ADMIN = 'superAdmin';
const CLIENT_ADMIN = 'clientAdmin';
const CLIENT_SELLER = 'clientSeller';

const parseUserType = (userType, clientSuperAdmin = false) => {
  if (userType === SUPER_ADMIN) return 'Super Administrador';
  if (userType === CLIENT_ADMIN) {
    if (clientSuperAdmin) return 'Super Administrador';
    return 'Administrador';
  }
  if (userType === CLIENT_SELLER) return 'Vendedor';
  return '';
};

module.exports = {
  SUPER_ADMIN,
  CLIENT_ADMIN,
  CLIENT_SELLER,
  parseUserType,
};
